export default function() {
    return true;
}



// WEBPACK FOOTER //
// ./src/core/filter/matchAll.js